import React from "react";
import styles from "../searchBook/searchBook.module.scss";
import { convertToCloudFrontUrl } from "../../../helper";

const BookRow = ({ book, onClick, taken }) => (
  <div
    className={`d-flex align-items-center gap-2 p-2 ${styles.recent} ${taken ? styles.taken : ""}`}
    onClick={onClick}
    aria-disabled={taken || undefined}
    title={taken ? "This book already has a summary" : undefined}
  >
    <img src={book.coverImage?.uploadedImageUrl ? convertToCloudFrontUrl(book.coverImage.uploadedImageUrl) : null} alt="" />
    <div className={styles.info}>
      <div className="d-flex align-items-center gap-1">
        <p className={styles.userName}>{book.bookName}</p>
      </div>
      {/* This is the book's author — it was labelled "Recommended by". */}
      <p className={styles.authorName}>
        by <span className="text-muted fw-medium">{book.authorName || "Unknown author"}</span>
      </p>
    </div>
    {taken && <span className={styles.takenTag}>Already has a summary</span>}
  </div>
);

/**
 * The summary form's book search results.
 *
 * `alreadySummarized`: matches the server kept out of the pickable list
 * because they already have a summary. Listed after it, dimmed and not
 * clickable, so searching for one says "already has a summary" rather than
 * "no books found" about a book that is in the library.
 */
function SearchBookLists({ onSuccess, SearchBookLists, alreadySummarized = [] }) {
  return (
    <div className={styles.sideBarContainer}>
      {SearchBookLists && SearchBookLists.map((book) => (
        book && <BookRow key={book.bookId} book={book} onClick={() => onSuccess(book.bookId)} />
      ))}
      {alreadySummarized.map((book) => (
        book && <BookRow key={book.bookId} book={book} taken />
      ))}
    </div>
  );
}

export default SearchBookLists;
